module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"details":"Protokoll","running":"Versand läuft: {done} von {total}","finished":"Abgeschlossen: {sent} gesendet, {failed} fehlgeschlagen (von {total})"},"en":{"details":"Log","running":"Sending: {done} of {total}","finished":"Finished: {sent} sent, {failed} failed (of {total})"}}')
  delete Component.options._Ctor
}
